import { render, staticRenderFns } from "./Adesione.vue?vue&type=template&id=f46820c4&scoped=true"
import script from "./Adesione.vue?vue&type=script&lang=js"
export * from "./Adesione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46820c4",
  null
  
)

export default component.exports